





















































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { State } from 'vuex-class';
import AppMessage from '../../core/models/appMessage';
import { Stripe, StripeElements, StripeElement, Card, StripeCardElement, loadStripe } from '@stripe/stripe-js';
import { PaymentSettingsApi } from '../api/paymentSettings';
import AddCard from '../components/AddCard.vue';
import { AuthStateInterface } from '../../auth/interfaces/authState';

@Component({
  components: {
    AddCard,
  },
})
export default class PaymentSettings extends Vue {
  public loading: boolean = false;
  public tableColumns: any[] = [];
  public tableData: Card[] = [];
  public defaultCardId: string = '';
  public deleteCardBtnLoading: boolean = false;
  public deleteCardModalOpen: boolean = false;
  public addCardModalOpen: boolean = false;
  public cardIdToDelete: string = '';
  public userHasActivePaidSub: boolean = false;
  private api: PaymentSettingsApi;
  @State('auth') private auth!: AuthStateInterface;

  constructor() {
    super();
    this.api = new PaymentSettingsApi();
  }

  public async created() {
    this.tableColumns = [
      {
        prop: 'brand',
        label: this.$t('paymentSettings.brand'),
        sortable: false,
      },
      {
        prop: 'last4',
        label: this.$t('paymentSettings.last4'),
        sortable: false,
      },
    ];

    this.refresh();
  }

  public async refresh() {
    this.loading = true;
    try {
      const result = await this.api.getCards();
      this.defaultCardId = await this.api.getDefaultCard();
      this.userHasActivePaidSub = await this.api.checkIfUserHasActivePaidSub();
      this.tableData = result.data;
    } catch (error) {
      AppMessage.show(this.$t('paymentSettings.tableDataLoadingError'), 'error');
    }
    this.loading = false;
  }

  public formatLast4(last4: string) {
    return '**** **** **** ' + last4;
  }

  public getExpDate(row: Card) {
    return row.exp_month + '/' + row.exp_year.toString().substr(2, 2);
  }

  public async setCardAsDefault(cardId: string) {
    this.loading = true;
    try {
      await this.api.setCardAsDefault(cardId);
      await this.refresh();
      AppMessage.show(this.$t('paymentSettings.cardSetAsDefaultSuccess'), 'success');
    } catch (error) {
      AppMessage.show(this.$t('paymentSettings.cardSetAsDefaultError'), 'error');
    }
    this.loading = false;
  }

  public deleteCardModal(cardId: string) {
    this.cardIdToDelete = cardId;
    this.deleteCardModalOpen = true;
  }

  public closeDeleteCardModal() {
    this.cardIdToDelete = '';
    this.deleteCardModalOpen = false;
  }

  public async deleteCard() {
    this.deleteCardBtnLoading = true;
    try {
      await this.api.deleteCard(this.cardIdToDelete);
      await this.refresh();

      AppMessage.show(this.$t('paymentSettings.cardDeleteSuccess'), 'success');
    } catch (error) {
      AppMessage.show(this.$t('paymentSettings.cardDeleteError'), 'error');
    }
    this.closeDeleteCardModal();
    this.deleteCardBtnLoading = false;
  }

  public closeAddCardModal() {
    this.addCardModalOpen = false;
  }

  public async addNewCard(token: string) {
    this.loading = true;
    try {
      await this.api.addNewCard(token);
      this.addCardModalOpen = false;
      await this.refresh();
      AppMessage.show(this.$t('paymentSettings.addCardSuccess'), 'success');
    } catch (error) {
      AppMessage.show(this.$t('paymentSettings.addCardError'), 'error');
    }
    this.loading = false;
  }
}
